import { Trans } from '@lingui/react/macro';
import { Box, Button, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useGtm } from 'shared/domains/tracking';
const UG_ID = Number(process.env.USER_GUIDING_RESOURCE_CENTER_ID);
export function ContentError(props) {
    const { title, description, refetch } = props;
    const { push } = useGtm();
    const handleClick = () => {
        if (process.env.NODE_ENV === 'production') {
            push({ event: 'open_user_guiding_resource_center' });
        }
        try {
            window.userGuiding.launchResourceCenter(UG_ID, { sidebarOpen: true });
        }
        catch (_a) {
            window.open('https://knowledgehub.miramis.co/', '_blank');
        }
    };
    return (<Box height="100%" width="100%" alignItems="center" justifyContent="center">
      <EmptyState icon={<Falcon icon="circle-xmark"/>} title={title} description={description} actions={<Box gap="md">
            <Button type="button" appearance="primary" size="small" onClick={() => refetch()}>
              <Trans>Retry</Trans>
            </Button>
            <Button type="button" appearance="secondary" size="small" onClick={handleClick}>
              <Trans>Support</Trans>
            </Button>
          </Box>}/>
    </Box>);
}
